import script from "./Gartenkultur-CRM-Settings.vue?vue&type=script&setup=true&lang=js"
export * from "./Gartenkultur-CRM-Settings.vue?vue&type=script&setup=true&lang=js"

import "./Gartenkultur-CRM-Settings.vue?vue&type=style&index=0&id=54789f56&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54789f56"]])

export default __exports__